import React, { useEffect, useRef, useState } from "react";
import { Card, Typography, Divider, Button, Spin } from "antd";
import { MdOutlineStickyNote2 } from "react-icons/md";
import Lottie from "lottie-react";
import messageDonation from "../../assets/success.json";
import messageError from "../../assets/error.json";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import {
  toCheckHyperPayStatus,
  toGetHyperPayKeys,
  toSavePayment,
} from "../../apis/actions/paymentMethods.actions";
import moment from "moment";
import {
  resetState,
  setShowPaiement,
} from "../../apis/slices/globalSlice";
import {
  setData,
  setIsMadaVisible,
  setIsVisible,
} from "../../apis/slices/hyperPaySlice";
import { resetDocumentAfterPaymentReturn } from "../../utils/clearModalBodyLocks";
import { toCreateAppointment } from "../../apis/actions/appointments.actions";
import { showNotitfication } from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { CloseOutlined } from "@ant-design/icons";
import RewardModal from "./Shop/RewardModal";
import { toGetProfil } from "../../apis/actions/auth.actions";
import { getGrandPayableTotalFromState } from "../../utils/paymentTotals";
import { getHyperPayBaseUrl } from "../../utils/hyperPay";

import { readLastPage } from "../../utils/lastPage";

const { Title, Text } = Typography;

const ResultMadaPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const hasRun = useRef(false);
  const [orderId, setOrderId] = useState("");
  const [retryAmount, seTRetryAmount] = useState(0);
  const [showRetry, SetShowRetry] = useState(false);
  const [localCart, setLocalCart] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [rewardLoyalty, setRewardLoyalty] = useState("");

  const { donationAmount } = useSelector((state: RootState) => state?.global);
  const [donationToDisplay, setDonationToDisplay] = useState(0);
  const [amountTodisplay, setAmountToDisplay] = useState(0);

  const dispatch = useDispatch<AppDispatch>();
  const {
    cart_id,
    my_cart,
    loyaltyPhone,
    loyaltyType,
    amount,
    walletAmount,
    services,
    products,
    discountAmount,
  } = useSelector((state: RootState) => state?.global);
  const { profil } = useSelector((state: RootState) => state?.login);

  const [state, setState] = useState<string>("");
  const queryParams = new URLSearchParams(location.search);
  const payment_id = queryParams.get("id");
  const type = queryParams.get("type");
  useEffect(() => {
    dispatch(toGetProfil(i18n.language));
    dispatch(toGetHyperPayKeys());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setIsVisible(false));
    dispatch(setIsMadaVisible(false));
    dispatch(setData(null));
    dispatch(setShowPaiement(false));
    resetDocumentAfterPaymentReturn();
  }, [dispatch]);

  const { keys } = useSelector((state: RootState) => state.tabby.HyperPayKeys);
  const hyperPayBaseUrl = getHyperPayBaseUrl(keys);

  useEffect(() => {
    if (
      cart_id &&
      cart_id !== "" &&
      !hasRun.current &&
      payment_id &&
      type === "hyperpay" &&
      keys?.entityIdMada &&
      keys?.token &&
      hyperPayBaseUrl
    ) {
      setLocalCart(my_cart);
      setDonationToDisplay(donationAmount);
      setAmountToDisplay(amount);
      hasRun.current = true;

      const checkAndSave = async () => {
        setLoading(true);

        const statusResult = (await dispatch(
          toCheckHyperPayStatus({
            checkoutId: payment_id,
            entityId: keys.entityIdMada,
            token: keys.token,
            base_url: hyperPayBaseUrl,
          })
        )) as any;

        const statusResponse = statusResult?.payload;

        if (
          statusResponse?.result?.code === "000.100.110" ||
          statusResponse?.result?.code === "000.100.112" ||
          statusResponse?.result?.code === "000.000.000" ||
          statusResponse?.result?.code === "000.200.000" ||
          statusResponse?.result?.description
            ?.toLowerCase()
            .includes("successfully processed")
        ) {
          await trySave();
        } else {
          setState("error");
          setLoading(false);
        }
      };

      const trySave = async () => {
        const paymentData = {
          amount: getGrandPayableTotalFromState(
            amount,
            donationAmount,
            walletAmount,
            services,
            products,
            discountAmount
          ),
          wallet_amount: walletAmount,
          transaction_id: payment_id,
          cart_id: cart_id,
          payment_type: type,
          donation_amount: Number(donationAmount),
          loyalty_type: loyaltyType,
          loyalty_phone: profil?.data?.phone,
        };

        const result = (await dispatch(
          toSavePayment({ data: paymentData, lang: i18n.language })
        )) as any;
        const response = result?.payload?.data?.result;

        if (response?.code === 200) {
          setState("success");
          setLoading(false);

          if (response?.require_alternate_phone) {
            dispatch(setShowPaiement(false));
            setOrderId(response?.order_id);
            seTRetryAmount(response?.amount);
            setRewardLoyalty(loyaltyType);
            SetShowRetry(true);
            toAddAppointment();
            dispatch(resetState());

            return;
          }

          dispatch(setShowPaiement(false));
          toAddAppointment();
          dispatch(resetState());
        } else {
          setState("error");
          setLoading(false);
        }
      };

      checkAndSave();
    }
  }, [cart_id, hyperPayBaseUrl, keys, payment_id, type]);

  const toAddAppointment = async () => {
    if (my_cart.service_ids.length > 0) {
      const success = (await dispatch(toCreateAppointment(my_cart))) as any;
      const response = success?.payload?.data?.result;

      if (response?.code === 200) {
        dispatch(resetState());
      } else {
        setState("error");
      }
    }
  };
  return (
    <div
      className="ac--payment-success-page"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      {loading ? (
        <Card
          className="payment-success-container"
          style={{
            textAlign: "center",
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            {i18n.language === "ar"
              ? "نقدر لكم انتظاركم !"
              : "We appreciate your patience !"}
          </div>
          <Spin
            size="large"
            tip={t("result.loading")}
            style={{ color: "purple" }}
          />
        </Card>
      ) : state === "success" ? (
        <Card className="payment-success-container">
          {/* زر الإغلاق المضاف */}
          <Button
            type="text"
            className="close-button"
            onClick={() => navigate("/")}
            icon={<CloseOutlined size={24} />}
            style={{
              position: "absolute",
              top: "16px",
              right: i18n.language === "ar" ? "unset" : "16px",
              left: i18n.language === "ar" ? "16px" : "unset",
              zIndex: 1,
            }}
          />

          <div className="payment-success-header">
            <Lottie
              animationData={messageDonation}
              loop={true}
              style={{ width: "100px" }}
            />
            <Title level={3} className="text-md success-title">
              {t("result.success")}
            </Title>
            <Text type="secondary" className="text-md">
              {t("result.thanks")}
            </Text>
            <div className="order-id text-xs">
              <MdOutlineStickyNote2 /> {payment_id}
            </div>
          </div>

          <Divider />

          <div className="payment-details">
            <div className="detail-row">
              <Text className="ac--title-page"> {t("result.date")}</Text>
              <Text className="text-md">{moment().format("YYYY/MM/DD")}</Text>
            </div>
            <div className="detail-row">
              <Text className="ac--title-page"> {t("result.number")}</Text>
              <Text className="text-sm">{localCart?.cart_id}</Text>
            </div>
            <div className="detail-row">
              <Text className="ac--title-page"> {t("result.method")}</Text>
              <Text className="text-md">
                {type === "hyperpay" ? t("Orderslist.payWithCard") : type}
              </Text>
            </div>

            <div className="detail-row total-row">
              <Text className="ac--title-page"> {t("result.amount")}</Text>
              <Text strong className="text-md  icon-saudi_riyal">
                {amountTodisplay + Number(donationToDisplay)}
                {/* {t("profile.currency")}*/}
              </Text>
            </div>
          </div>
          <div className="ac--payment-btn">
            <Button
              size="large"
              block
              onClick={() => navigate("/profile", { state: { activeTab: 2 } })}
              className="text-md-bold"
            >
              {t("result.back")}
              {i18n.language === "ar" ? <FaArrowLeft /> : <FaArrowRight />}
            </Button>
          </div>
        </Card>
      ) : (
        state === "error" && (
          <Card className="payment-success-container">
            {/* زر الإغلاق المضاف */}
            <Button
              type="text"
              className="close-button"
              onClick={() => navigate(readLastPage())}
              icon={<CloseOutlined size={24} />}
              style={{
                position: "absolute",
                top: "16px",
                right: i18n.language === "ar" ? "unset" : "16px",
                left: i18n.language === "ar" ? "16px" : "unset",
                zIndex: 1,
              }}
            />

            <div className="payment-success-header">
              <Lottie
                animationData={messageError}
                loop={true}
                style={{ width: "100px" }}
              />
              <Title level={3} className="success-title">
                {t("result.failed")}
              </Title>
              <Text type="secondary"> {t("result.again")}</Text>
            </div>

            <Divider />
            <div className="ac--payment-btn">
              <Button
                size="large"
                block
                onClick={() => navigate(readLastPage())}
                className="text-md-bold"
              >
                {t("result.again")}
                {i18n.language === "ar" ? <FaArrowLeft /> : <FaArrowRight />}
              </Button>
            </div>
          </Card>
        )
      )}
      <RewardModal
        open={showRetry}
        amount={retryAmount}
        order_id={orderId}
        loyaltyType={rewardLoyalty}
        onClose={() => SetShowRetry(false)}
      />
    </div>
  );
};

export default ResultMadaPage;
